export default "__VITE_ASSET__D56Onw2D__"